<template>
  <template v-if="!isLoadError">
    <register-form @submit.prevent="showConfirmModal">
      <form-caption v-if="pageTitle" :text="pageTitle" />
      <span class="h5 border-bottom border-2 mb-3">仲介業者情報</span>
      <vuex-hidden-form-item bind="uuid" />
      <vuex-text-form-item bind="company_name" label="仲介業者名" :required="true" />
      <vuex-text-form-item bind="company_name_kana" label="仲介業者名（カナ）" :required="true" />
      <vuex-licence-form-item :required="true" />
      <vuex-postal-code-form-item :required="true" />
      <vuex-prefecture-form-item :required="true" />
      <vuex-text-form-item bind="address1" label="市区町村" :required="true" />
      <vuex-text-form-item bind="address2" label="番地・建物など" :required="true"/>
      <vuex-text-form-item bind="tel" label="電話番号" :required="true" />
      <vuex-text-form-item bind="fax" label="FAX番号" />

      <span class="h5 border-bottom border-2 my-3">管理者情報</span>
      <vuex-text-form-item bind="name" label="氏名" :required="true" />
      <vuex-text-form-item bind="name_kana" label="氏名（カナ）" :required="true" />
      <text-browse-item :value="email" label="メールアドレス" />
      <vuex-password-form-item bind="password" label="パスワード" :required="true" />
      <vuex-switch-form-item bind="use_two_step_authentication" label="２段階認証" />
      <vuex-textarea-form-item bind="contact" label="連絡先" />
      <vuex-text-form-item bind="office" label="店舗名" />
      <vuex-text-form-item bind="department" label="部署名" />
    </register-form>
    <teleport to="body">
      <register-confirm-modal ref="confirmModal" @register="doRegister" />
    </teleport>
  </template>
  <template v-else>
    <plain-form>
      <div v-if="isLoadErrorConflict">
        <p>既に登録済みのメールアドレスです。</p>
      </div>
      <div v-else-if="isLoadErrorGone">
        <p>URLの有効期限が過ぎました。</p>
        <p>下記リンクより、再度操作をやり直してください。</p>
        <router-link :to="{name:'PrivacyPolicyAgreement'}">個人情報の取り扱いについて</router-link>
      </div>
    </plain-form>
  </template>
</template>

<script>
import {mapState} from "vuex";
import RegisterForm from "@/views/templates/forms/RegisterForm";
import FormCaption from '@/views/atoms/FormCaption'
import VuexHiddenFormItem from "@/views/molecules/formItems/VuexHiddenFormItem";
import VuexTextFormItem from "@/views/molecules/formItems/VuexTextFormItem";
import VuexLicenceFormItem from "@/views/molecules/formItems/VuexLicenceFormItem";
import VuexPostalCodeFormItem from "@/views/molecules/formItems/VuexPostalCodeFormItem";
import VuexPrefectureFormItem from "@/views/molecules/formItems/VuexPrefectureFormItem";
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import VuexPasswordFormItem from "@/views/molecules/formItems/VuexPasswordFormItem";
import VuexTextareaFormItem from "@/views/molecules/formItems/VuexTextareaFormItem";
import RegisterConfirmModal from "@/views/molecules/modals/RegisterConfirmModal";
import PlainForm from '@/views/templates/forms/PlainForm'
import VuexSwitchFormItem from "@/views/molecules/formItems/VuexSwitchFormItem";

export default {
  name: "Registratiregister",
  components: {
    RegisterForm,
    FormCaption,
    VuexHiddenFormItem,
    VuexTextFormItem,
    VuexLicenceFormItem,
    VuexPostalCodeFormItem,
    VuexPrefectureFormItem,
    TextBrowseItem,
    VuexPasswordFormItem,
    VuexTextareaFormItem,
    RegisterConfirmModal,
    PlainForm,
    VuexSwitchFormItem,
  },
  provide: {
    bindModule: 'brokerage_company_register_form'
  },
  computed: {
    ...mapState('brokerage_company_register_form', {
      email: state => state.data.email,
      management_company_code: state => state.data.management_company_code,
      isLoadErrorConflict: state => state.isLoadErrorConflict,
      isLoadErrorGone: state => state.isLoadErrorGone,
    }),
    pageTitle() {
      return this.$store.state.pageTitle;
    },
    isLoadError() {
      return this.isLoadErrorConflict || this.isLoadErrorGone;
    },
  },
  mounted() {
    this.$store.dispatch('startPageLoading').then(() => {
      this.$store.dispatch('brokerage_company_register_form/load', {
        uuid: this.$route.query.uuid
      });
    }).catch(reason => this.$root.failApi(reason)).finally(() => this.$store.dispatch('stopPageLoading'));
  },
  methods: {
    showConfirmModal() {
      this.$refs.confirmModal.show();
    },
    doRegister() {
      if (this.management_company_code) {
        localStorage.setItem('managementCompanyCode', this.management_company_code);
      } else {
        localStorage.removeItem('managementCompanyCode');
      }
      this.$store.dispatch('brokerage_company_register_form/register').then(() => {
        const managementCompanyCode = localStorage.getItem('managementCompanyCode');
        if (managementCompanyCode) {
          this.$router.push({name: 'Login', query: {mccd: managementCompanyCode}});
        } else {
          this.$router.push({name: 'Login'});
        }
      }).catch(reason => this.$root.failApi(reason));
    }
  },
}
</script>
